import { render, staticRenderFns } from "./PointSelectDropdown.vue?vue&type=template&id=0f4f132a&scoped=true"
import script from "./PointSelectDropdown.vue?vue&type=script&lang=js"
export * from "./PointSelectDropdown.vue?vue&type=script&lang=js"
import style0 from "./PointSelectDropdown.vue?vue&type=style&index=0&id=0f4f132a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f132a",
  null
  
)

export default component.exports